<template>
  <v-row class="ma-1">
    <v-col md="12" cols="12">
      <v-toolbar class="" color="primary" dark flat>
        <v-toolbar-title>Lokality</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-text-field
          solo-inverted
          flat
          hide-details
          v-model="filter"
          prepend-inner-icon="mdi-magnify"
          clearable
        />
        <v-btn @click="addLokalita()" text>Pridať</v-btn>
      </v-toolbar>
    </v-col>
    <v-col md="12" cols="12">
      <v-data-table
        :headers="headers"
        :items="lokality"
        sort-by="Name"
        :items-per-page="10"
        :search="filter"
        class="elevation-1 clickableTable"
        @click:row="viewLokalita($event)"
        ref="dataTable"
      >
        <!--template v-slot:item.action="{ item }">
          <v-btn
            class="mx-2"
            fab
            dark
            x-small
            color="primary"
            @click="editLokalita(item)"
          >
            <v-icon>mdi-pencil</v-icon>
          </v-btn>
        </!--template-->
      </v-data-table>
      <div class="text-right">
        <v-tooltip bottom>
          <template v-slot:activator="{ on }">
            <download-excel
              :data="lokality"
              :fields="exportFields"
              class="exportXLS"
            >
              <v-icon v-on="on">mdi-microsoft-excel</v-icon>
            </download-excel>
          </template>
          <span>Export do xls</span>
        </v-tooltip>
      </div>
    </v-col>
    <lokalita-detail
      ref="dialogLokalita"
      @change="readLokality()"
    ></lokalita-detail>
  </v-row>
</template>

<script>
import LokalitaDetail from "../components/LokalitaDetail.vue"
import DownloadExcel from "vue-json-excel"

export default {
  data: () => ({
    headers: [
      { text: "ID", align: "left", sortable: true, value: "LOKID" },
      { text: "Názov", align: "left", sortable: true, value: "Name" },
      {
        text: "Inžinierskogeologický región",
        align: "left",
        sortable: false,
        value: "IgReg"
      },
      {
        text: "Inžinierskogeologická oblasť",
        align: "left",
        sortable: false,
        value: "IgObl"
      },
      {
        text: "Popis",
        align: "left",
        sortable: false,
        value: "Popis"
      }
    ],
    exportFields: {
      ID: "LOKID",
      Názov: "Name",
      "Inžinierskogeologický región": "IgReg",
      "Inžinierskogeologická oblasť": "IgObl",
      Popis: "Popis"
    },
    lokality: [],
    filter: ""
  }),

  components: {
    LokalitaDetail,
    DownloadExcel
  },

  methods: {
    readLokality: async function() {
      try {
        let response = await this.$axios.get("/r/lokality")
        if (response.status === 200) {
          this.lokality = response.data
        } else {
          this.$store.commit("alert", response.data.Error)
        }
      } catch (error) {
        this.$store.commit("alert", error.toString())
      }
    },

    addLokalita: function() {
      let newLokID = 0
      for (const l of this.lokality) {
        let lokid = parseInt(l.LOKID, 10)
        newLokID = Math.max(lokid, newLokID)
      }
      newLokID = newLokID + 1
      this.$refs.dialogLokalita.show({
        ID: null,
        LOKID: newLokID.toString(),
        Literatura: []
      })
    },

    /*
    editLokalita: function(lokalita) {
      this.$refs.dialogLokalita.show(lokalita);
    },*/

    viewLokalita: function(lokalita) {
      this.$router.push({ name: "lokalita", params: { id: lokalita.ID } })
    }
  },

  mounted: async function() {
    console.log("lokality mounted")
    await this.$store.dispatch("fetchme", this.$axios)
    await this.readLokality()
  }
}
</script>
